export enum WidgetType {
    BLOTTER = 'blotter',
    CANDLESTICK_TILE = 'candlestickTile',
    CORPORATE_ACTIONS = 'corporateActions',
    CORPORATE_ACTIONS_CAPSULE = 'corporateActionsCapsule',
    DARK_VENUE_HEATMAP = 'darkVenueHeatmap',
    EST_TRADE_COST_WIDGET = 'estTradeCostWidget',
    EST_TRADE_COST_COMPARISON_WIDGET = 'estTradeCostComparisonWidget',
    EXPERTISE_MAKE = 'expertiseMake',
    EXPERTISE_NIGHTHAWK = 'expertiseNighthawk',
    EXPERTISE_DNA = 'expertiseDna',
    HistoricalPercentageChangeWidget = 'historicalPercentageChangeWidget',
    HistoricalPercentageChangeCapsule = 'historicalPercentageChangeCapsule',
    FILLS_GRAPH = 'fillsGraph',
    INDEX_EVENTS = 'indexEvents',
    LIQUIDITY_SUMMARY = 'liquiditySummary',
    MY_PORTFOLIO_CAPSULES = 'myPortfolioCapsules',
    OPEN_SUBMISSIONS = 'openSubmissions',
    OPEN_SUBMISSIONS_CAPSULE = 'openSubmissionsCapsule',
    ORDER_FILLS_BY_VENUE_CAPSULE = 'orderFillsByVenueCapsule',
    ORDER_FILLS_BY_VENUE_TYPE_CAPSULE = 'orderFillsByVenueTypeCapsule',
    ORDER_LIQUIDITY_CAPSULE = 'orderLiquidityCapsule',
    PERF_VS_INDEX_CAPSULE = 'perfVsIndexCapsule',
    PL_CAPSULE = 'plCapsule',
    PORTFOLIO_PL = 'portfolioPl',
    PORTFOLIO_RETURNS = 'portfolioReturns',
    PORTFOLIO_SUMMARY = 'portfolioSummary',
    PREDICTED_CLOSE_VOLUME_CAPSULE = 'predictedCloseVolumeCapsule',
    PREDICTED_VOLUME_CAPSULE = 'predictedVolumeCapsule',
    OBV_TILE = 'obvTile',
    RSI_TILE = 'rsiTile',
    PFE_TILE = 'pfeTile',
    INTRA_DAY_PROFILE = 'intradayProfiles',
    ORDER_VOLUME_PROFILE = 'orderVolumeProfile',
    OUTLIERS_WIDGET = 'outliersWidget',
    SUPPORT_VISUALISATION = 'supportVisualisation',
    STRATEGY_PARAMETERS = 'strategyParameters',
    SYMBOL_INFO = 'symbolInfo',
    SYMBOL_INFO_CAPSULE = 'symbolInfoCapsule',
    SYMBOL_TILE = 'symbolTile',
    TILES = 'tiles',
    TRADE_OPTIMIZER = 'tradeOptimizer',
    VENUE_ANALYSIS = 'venueAnalysis',
    VENUE_TYPE_CAPSULE = 'venueTypeCapsule',
    VENUE_EXEC_CAPSULE = 'venueExecCapsule',
    VOLUME_CAPSULE = 'predictedVsActualTile',
    VOLUME_CURVE = 'volumeCurve',
    /*
     * Special case widget type for widgets type loaded in a layout but not recognised in here
     * Required due to sharing layout databases - we may load layouts referencing widgets we don't support yet
     */
    UNKNOWN = 'unknown',
}
